import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { UserNotification } from '../model/userNotification';

export const USER_NOTIFICATIONS = new InjectionToken<Observable<UserNotification>>('User Notifications');
